var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationPin2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0A8.5 8.5 0 0 0 4 8.5c0 4.977 4.983 12.897 7.318 15.917a1.494 1.494 0 0 0 2.366.002C16.02 21.406 21 13.507 21 8.5A8.5 8.5 0 0 0 12.5 0zm0 11A3.5 3.5 0 1 1 16 7.5a3.5 3.5 0 0 1-3.5 3.5z",
    id: "budicon-location-pin"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin2);
export default __webpack_public_path__ + "static/media/Location-Pin 2.b9feaab6c13a99800d1288200ad3ed72.svg";
export { ForwardRef as ReactComponent };